/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import App from "./App";
import { BrowserRouter as Router, Route } from "react-router-dom";
import {
  createGenerateClassName,
  StylesProvider,
} from "@material-ui/core/styles";
import { Provider } from "react-redux";
import axios from "axios";
import store from "./store/store";
import { setupAxios } from "./services/api/setupAxios";
import "./assets/css/tailwind-output.css";

/* injects interceptors */
setupAxios(axios, store);

const generateClassName = createGenerateClassName({
  seed: "asidemenu",
});

import "./assets/sass/index.scss";
import { DownTime } from "Components/downtime";

export default function Root() {
  return (
    <StylesProvider generateClassName={generateClassName}>
      <Provider store={store}>
      <Router>
        <Route path="/">
          <App />
          <DownTime />
        </Route>
      </Router>
      </Provider>
    </StylesProvider>
  );
}
